// Single source of truth for the one contact address My Silo publishes.
//
// Jun 2026 (Randy). Before this there were THREE published addresses and none
// of them could receive mail: `support@my-silo.com` on the Refund Policy,
// Terms, Privacy and the voucher restriction notice (my-silo.com has no MX
// records at all), `support@mysilo.app` on the Termination Policy (mysilo.app
// has no MX either), and `mysilo@send.easttactics.com`, whose only MX is
// Amazon SES's bounce processor — mail there is silently discarded.
//
// Those pages are where customers are told to send DMCA notices, GDPR/CCPA
// requests, arbitration opt-outs and billing-error claims, all on deadlines we
// promised in writing. One address, in one file, verified to receive.
//
// TO CHANGE IT: edit this constant only. Nothing else hardcodes an address —
// `/app/tests/test_email_registry.py` fails the build if anything does.
export const SUPPORT_EMAIL = "support@easttactics.com";
